<template>
  <section>
    <p class="font-size--13 mb-3">
      📌 정부 지원 크라우드 펀딩(대출형)사업으로 아래 서류 제출이 필요해요!
    </p>

    <div>
      <p>
        1. 소상공인 지식배움터 온라인 교육이수증 (<a target="_blank" href="https://edu.sbiz.or.kr"
          >https://edu.sbiz.or.kr</a
        >)
      </p>
      <p>
        - 회원가입 후 지식배움터 > 온라인교육> 개별교육 > 지원사업 > 2023년 우리동네 크라우드펀딩
        지원사업 교육
      </p>
    </div>

    <div>
      <p>
        2. 소상공인 확인서 발급 (<a target="_blank" href="https://sminfo.mss.go.kr"
          >https://sminfo.mss.go.kr</a
        >)
      </p>
      <p>- 중소기업확인서 발급신청 (착한임대인 세액공제용은 불가)</p>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
section {
  background-color: #f0f5f9;
  color: #333;
  padding: 16px 12px;

  p {
    margin-bottom: 0;
    line-height: 1.4;
  }

  > div {
    &:not(:last-child) {
      margin-bottom: 16px;
    }

    p:first-child {
      font-weight: 900;
      margin-bottom: 4px;
    }
    p:last-child {
      font-size: 13px;
    }
  }
}
</style>
